import React from 'react'

type InterestResultsProps = {
  scrollPosition?: { scrollTop: number }
  handleScrollToTop?: () => void
}

const InterestResults = (_props: InterestResultsProps) => {
  return <div>Interest Results</div>
}

export default InterestResults
